import DOMPurify from './dompurify-proxy';

/**
 * Sanitize cookie value
 *
 * Cette fonction assainit une valeur potentiellement dangereuse à l'aide de DOMPurify.
 * Vous pouvez enrichir cette fonction avec d'autres contrôles si nécessaire.
 * @param {string} value
 * @returns {string}
 */
export function sanitizeCookieValue(value) {
  if (typeof value !== 'string') {
    return value;
  }
  return DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}
